import { FORM_ERROR } from 'final-form';
import moment from 'moment';
import validations from '../validations';

const isDateRange1WeekOrLess = (filed_from, filed_to) => {
  // definitely not less than 1 week if not filled in
  if (!filed_from) return false;
  if (!filed_to) return false;

  // since nothing can be filed in the future,
  // we consider blank filedTo to be same as TODAY()
  const endDate = filed_to || moment();

  return endDate.diff(filed_from, 'weeks', true) <= 1.0;
};

export const validateBankruptcy = (values) => {
  const errors = {};

  if (!values.court_code) {
    errors.court_code = 'Region is required';
  }

  if (values.case_no && !validations.CASE_NUMBER(values.case_no)) {
    errors.case_no = 'Invalid case number format.';
  }

  if (values.ssntin && !validations.SSN_OR_TIN(values.ssntin)) {
    errors.ssntin = 'Invalid SSN/TIN.';
  }

  if (Object.keys(errors).length > 0) {
    errors[FORM_ERROR] = Object.values(errors)
      .reduce((acc, error) => (acc ? `${acc}\n${error}` : error), '');

    return errors;
  }

  // Validate Input field combinations ----------------------------------------
  // case_no is good enough
  if (values.case_no) return;
  // SSN is good enough
  if (values.ssntin) return;
  // Last and first ok
  if (values.last_business_name && values.first_name) return;
  // Last and small enough date range is OK
  if (values.last_business_name && isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
  // 1 week date range
  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;

  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
    errors[FORM_ERROR] = 'Date range must be no greater than 1 Week';
    errors.filed_from = 'error';
    errors.filed_to = 'error';

    return errors;
  }

  if (values.last_business_name && !values.first_name
    && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
    errors[FORM_ERROR] = 'Last / Business Name requires First name or Date Filed Range not greater than 1 week';
    errors.first_name = 'error';
    errors.filed_from = 'error';
    errors.filed_to = 'error';

    return errors;
  }

  errors[FORM_ERROR] = [
    'Please enter at least one combination:',
    '- Case Number',
    '- Last Name and First Name',
    '- Last / Business Name and Date Filed Range not greater than 1 week',
    '- SSN/TIN',
    '- Date Filed Range not greater than 1 week',
  ].join('\n');

  errors.case_no = 'error';
  errors.last_business_name = 'error';
  errors.first_name = 'error';
  errors.filed_from = 'error';
  errors.filed_to = 'error';
  errors.ssntin = 'error';

  return errors;
};


export const validateCivil = (values) => {
  const errors = {};

  if (!values.court_code) {
    errors.court_code = 'Region is required';
  }

  if (values.case_no && !validations.CASE_NUMBER(values.case_no)) {
    errors.case_no = 'Invalid case number format.';
  }

  if (Object.keys(errors).length > 0) {
    errors[FORM_ERROR] = Object.values(errors)
      .reduce((acc, error) => (acc ? `${acc}\n${error}` : error), '');

    return errors;
  }

  // Validate Input field combinations ----------------------------------------
  // case_no is good enough
  if (values.case_no) return;
  // // Last and first ok
  // if (values.last_business_name && values.first_name) return;
  // // Last and small enough date range is OK
  // if (values.last_business_name && isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;
  // 1 week date range
  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;

  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
    errors[FORM_ERROR] = 'Date range must be no greater than 1 Week';
    errors.filed_from = 'error';
    errors.filed_to = 'error';

    return errors;
  }

  // if (values.last_business_name && !values.first_name
  //   && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
  //   errors[FORM_ERROR] = 'Last / Business Name requires First name or Date Filed Range not greater than 1 week';
  //   errors.first_name = 'error';
  //   errors.filed_from = 'error';
  //   errors.filed_to = 'error';
  //
  //   return errors;
  // }

  errors[FORM_ERROR] = [
    'Please enter at least one combination:',
    '- Case Number',
    // '- Last Name and First Name',
    // '- Last / Business Name and Date Filed Range not greater than 1 week',
    '- Date Filed Range not greater than 1 week',
  ].join('\n');

  errors.case_no = 'error';
  // errors.last_business_name = 'error';
  // errors.first_name = 'error';
  errors.filed_from = 'error';
  errors.filed_to = 'error';

  return errors;
};


export const validateAppellate = (values) => {
  const errors = {};

  if (!values.court_code) {
    errors.court_code = 'Region is required';
  }

  if (values.case_no && !validations.CASE_NUMBER(values.case_no)) {
    errors.case_no = 'Invalid case number format.';
  }

  if (Object.keys(errors).length > 0) {
    errors[FORM_ERROR] = Object.values(errors)
      .reduce((acc, error) => (acc ? `${acc}\n${error}` : error), '');

    return errors;
  }

  // Validate Input field combinations ----------------------------------------
  // case_no is good enough
  if (values.case_no) return;
  // Party / Attorney name ok
  if (values.party_name) return;
  // 1 week date range
  if (isDateRange1WeekOrLess(values.filed_from, values.filed_to)) return;

  if (values.filed_from && !isDateRange1WeekOrLess(values.filed_from, values.filed_to)) {
    errors[FORM_ERROR] = 'Date range must be no greater than 1 Week';
    errors.filed_from = 'error';
    errors.filed_to = 'error';

    return errors;
  }

  errors[FORM_ERROR] = [
    'Please enter at least one combination:',
    '- Case Number',
    '- Party / Attorney',
    '- Date Filed Range not greater than 1 week',
  ].join('\n');

  errors.case_no = 'error';
  errors.party_name = 'error';
  errors.filed_from = 'error';
  errors.filed_to = 'error';

  return errors;
};



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/formValidation.js